import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtDate, fmtDuration } from "@/lib/constants";
import { Markdown } from "@/components/course/Markdown";
import { RevisionSheet } from "@/components/course/RevisionTab";

export default function PrintView() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const type = params.get("type") === "fiche" ? "fiche" : "notes";
  const [c, setC] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.documentElement.classList.remove("dark");
    api.get(`/courses/${id}/export/pdf`).then(({ data }) => setC(data)).catch((e) => setError(errMsg(e)));
  }, [id]);

  useEffect(() => {
    if (!c) return;
    document.title = `${c.title} — ${type === "fiche" ? "Fiche de révision" : "Notes"}`;
    const t = setTimeout(() => window.print(), 700);
    return () => clearTimeout(t);
  }, [c, type]);

  if (error) return <div className="p-10 text-center" data-testid="print-error">{error}</div>;
  if (!c) return <div className="flex justify-center p-20"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (type === "fiche" && !c.revision) return <div className="p-10 text-center">Génère d'abord ta fiche de révision.</div>;

  return (
    <div className="mx-auto max-w-3xl bg-white p-8 text-slate-900 sm:p-12" data-testid="print-view">
      <div className="no-print mb-6 flex justify-end">
        <button data-testid="print-button" onClick={() => window.print()} className="bg-brand inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white"><Printer className="h-4 w-4" /> Enregistrer en PDF</button>
      </div>
      <p className="text-xs uppercase tracking-[0.2em] text-slate-500">NoteMyClass AI · {c.subject} · {fmtDate(c.created_at)}{c.duration_sec ? ` · ${fmtDuration(c.duration_sec)}` : ""}</p>
      {type === "fiche" ? (
        <>
          <h1 className="mb-6 mt-2 text-3xl font-extrabold">Fiche de révision — {c.title}</h1>
          <RevisionSheet r={c.revision} />
        </>
      ) : (
        <div className="mt-4"><Markdown>{c.notes_markdown}</Markdown></div>
      )}
    </div>
  );
}
